///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, toastSuccessActionCreators, articleManagerActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'
import { uriList } from '../../routings/settings/RouteList'

const getAvailableLists = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_ARTICLE_AVAILABLE_LISTS()
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(articleManagerActionCreators.getAvailableListsSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleManagerActionCreators.getAvailableListsFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const createArticle = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CREATE_ARTICLE()

	const redirectRequest = `${uriList.distributionItems}${uriList.distributionGroupRepo}`

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.data)

		yield put(articleManagerActionCreators.createArticleSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast('toast__itemsRef__creation', redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleManagerActionCreators.createArticleFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getArticleItem = function* ({ payload }) {
	const idItem = payload.id
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_ARTICLE_ITEM(idItem)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(articleManagerActionCreators.getArticleItemSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleManagerActionCreators.getArticleItemFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateArticle = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idItem = payload.id
	const apiCall = R.UPDATE_ARTICLE(idItem)

	const redirectRequest = `${uriList.distributionItems}${uriList.distributionGroupRepo}`

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, payload.data)

		yield put(articleManagerActionCreators.updateArticleSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast('toast__itemsRef__update', redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleManagerActionCreators.updateArticleFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const deleteArticle = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idItem = payload.id
	const apiCall = R.POST_DELETE_ITEM(idItem)

	const redirectRequest = `${uriList.distributionItems}${uriList.distributionGroupRepo}`

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(articleManagerActionCreators.deleteArticleSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast('toast__itemReferential_deleteItem', redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleManagerActionCreators.deleteArticleFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_ARTICLE_AVAILABLE_LISTS, getAvailableLists)
	yield takeLatest(ActionsTypes.CREATE_ARTICLE, createArticle)
	yield takeLatest(ActionsTypes.GET_ARTICLE_ITEM, getArticleItem)
	yield takeLatest(ActionsTypes.UPDATE_ARTICLE, updateArticle)
	yield takeLatest(ActionsTypes.DELETE_ARTICLE, deleteArticle)
}

export default sagas
